import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import "../styles/floatingButton.css";

function LanguageSelectPage() {
  const navigate = useNavigate();

  return (
    <>
      <Container className="mt-5 text-center">
        <h1>Prayers In Silence</h1>
        <h4 className="mb-4">Select a Language</h4>
        <div className="d-grid gap-3">
          <Button
            className="glass-button bg-transparent border-0"
            onClick={() => navigate("/en")}
          >
            English
          </Button>
          <Button
            className="glass-button bg-transparent border-0"
            onClick={() => navigate("/es")}
          >
            Español
          </Button>
          <Button
            className="glass-button bg-transparent border-0"
            onClick={() => navigate("/ru")}
          >
            Русский
          </Button>
          <Button
            className="glass-button bg-transparent border-0"
            onClick={() => navigate("/tl")}
          >
            Tagalog
          </Button>
        </div>
      </Container>

    </>
  );
}

export default LanguageSelectPage;
